import React, { useState } from "react";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import classnames from "classnames";
import moment from "moment-timezone";
import Button from "@material-ui/core/Button";
import { formatDate } from "../../UpcomingRides/RideCard/helpers";
import { useStyles } from "./styles";
import { ReactComponent as ClockIcon } from "./clock.svg";
import { ReactComponent as ArrowRightIcon } from "./arrow_rigth_small.svg";
import TimeComponent from "./TimeComponent";
import DateComponent from "./DateComponent";
import { ReactComponent as CloseIcon } from "./close_icon.svg";

export default React.memo((props => {
  const setDateTimeZone = (value) => moment.tz(value, "America/New_York");

  const [ radioValue, setRadioValue ] = useState("nowDate");
  // const [ radioValue, setRadioValue ] = useState("calendar");
  const [ dateTime, setDateTime ] = useState(undefined);
  const [ time, setTime ] = useState(setDateTimeZone(new Date())
    .format("HH:mm"));
  const [ date, setDate ] = useState(undefined);
  const [ timeErrors, setTimeErrors ] = useState(undefined);
  const [ stateView, setStateView ] = useState(false);
  const [ minDate, setMinDate ] = useState(setDateTimeZone(new Date())
    .valueOf());
  const classes = useStyles();

  React.useEffect(() => {
    const momentTime = moment(time, "HH:mm");
    const momentDate = moment(date);
    setDateTime(setDateTimeZone(new Date())
      .set("hour", momentTime.get("hour"))
      .set("minute", momentTime.get("minute"))
      .set("date", momentDate.get("date"))
      .set("month", momentDate.get("month"))
      .set("year", momentDate.get("year")),
    );
  }, [ date, time ]);

  React.useEffect(() => {
    timeValidation(dateTime);
  }, [ dateTime ]);

  const saveDateTime = () => {
    if (dateTime && radioValue === "calendar") {
      if (!timeErrors) {
        setStateView(!stateView);
        props.onChange(dateTime.valueOf());
      }
    } else {
      setStateView(!stateView);
      setDateTime(0);
      props.onChange(0);
    }
  };

  const timeValidation = (date) => {
    setTimeErrors(date?.isBefore?.(moment(new Date()), "minutes") || false);
  };

  const updateDateAndTimeFields = () => {
    setTime(setDateTimeZone(new Date())
      .format("HH:mm"));
    setDate(Date.now());
    setMinDate(setDateTimeZone(new Date())
      .valueOf());
  };

  const renderOption = (key, label, children, autoFocus = false) =>
    <div className={classes.optionBlock}>
      <FormControlLabel
        classes={{ label: classes.optionStyle }}
        value={key}
        onClick={() => {
          if (key === "nowDate") {
            updateDateAndTimeFields();
          }
        }}
        control={
          <Radio
            autoFocus={autoFocus}
            disableRipple
            checkedIcon={<div className={classnames(classes.icon, classes.checkedIcon)} />}
            icon={<div className={classes.icon} />}
          />
        }
        label={label}
      />
      {radioValue === "calendar" && children}
    </div>;

  const renderCalendar = () =>
    <>
      <DateComponent
        value={date}
        onChange={(value) => {

          setDate(moment(value)
            .valueOf());
        }}
        minDate={minDate}
        classes={classes}
      />
      <TimeComponent
        value={time}
        onChange={({ target: { value } }) => setTime(value)}
        classes={classes}
        timeErrors={timeErrors}
      />
    </>;

  return (
    <div className={classes.wrapper}>
      {!stateView ?
        <div
          onClick={() => setStateView(!stateView)}
          className={classes.staticText}
        >
          <div className={classes.staticTextMain}>
            <ClockIcon />
            {
              props.value ?
                formatDate(props.value)
                : "Now"
            }
          </div>
          <div className={classes.staticTextArrow}>
            <ArrowRightIcon />
          </div>
        </div>
        :
        <div className={classes.dateTimeContainer}>
          <h5 className={classes.title}>
            Choose date and time
            <CloseIcon
              onClick={() => setStateView(!stateView)}
              className={classes.backButton}
            />
          </h5>
          <RadioGroup
            className={classes.radioGroup}
            value={radioValue}
            onChange={({ target }) => {
              setRadioValue(target.value);
              if (target.value === "nowDate") {
                setDate(undefined);
              }
            }}
          >
            {renderOption("nowDate", "Now", "")}
            {renderOption("calendar", "Make a reservation", renderCalendar())}
          </RadioGroup>
          <Button type='button'
                  onClick={saveDateTime}
                  color="primary"
                  variant='contained'
                  className={classes.button}
                  disabled={timeErrors}
          >
            {
              "Confirm "
              +
              (
                dateTime
                  ? formatDate(dateTime)
                  : "Now"
              )
            }
          </Button>
        </div>
      }
    </div>
  );
}));
